module.exports = __webpack_public_path__ + "static/media/machine-occupied.0b377c81.svg";